import { NotificationFeedNames } from '@core/model';

type NotificationPayloads = {
  'global-testRealTime-triggered': { param1: string; param2: string };
  'integration-analytics-elosResponse-received': { authorizationNumber: string };
  'integration-analytics-rtd-recommended': { authorizationNumber: string };
  'integration-analytics-rtd-not-recommended': { authorizationNumber: string };
};

export type MessageTypes = 'info' | 'warning' | 'danger' | 'comment';

type NotificationMapping<Key extends NotificationFeedNames> = {
  type: MessageTypes;
  message: (payload: NotificationPayloads[Key]) => string;
};

export const NotificationMappings: { [Key in NotificationFeedNames]: NotificationMapping<Key> } = {
  'global-testRealTime-triggered': {
    type: 'info',
    message: (payload) => {
      return `Console .log ${payload.param1} and ${payload.param2}`;
    },
  },
  'integration-analytics-elosResponse-received': {
    type: 'info',
    message: (payload) => {
      return `ELOS Update received, ${payload.authorizationNumber}`;
    },
  },
  'integration-analytics-rtd-recommended': {
    type: 'info',
    message: (payload) => {
      return `Ready To Discharge: Recommended, ${payload.authorizationNumber}`;
    },
  },
  'integration-analytics-rtd-not-recommended': {
    type: 'info',
    message: (payload) => {
      return `Ready To Discharge: Not Recommended, ${payload.authorizationNumber}`;
    },
  },
};
